import { useEffect, useState } from 'react';

import {
  FormFieldsDisabledContext,
  FormFieldsDisabledContextType,
  useFormFieldsDisabled,
} from './formFieldsDisabled.context';

export const FormFieldsDisabledProvider = ({
  children,
  isDisabled,
  inheritParentDisabled = true,
}: React.PropsWithChildren<{
  isDisabled: boolean;
  inheritParentDisabled?: boolean;
}>) => {
  const parentContext = useFormFieldsDisabled();
  const [disabled, setDisabled] =
    useState<FormFieldsDisabledContextType['disabled']>(undefined);

  useEffect(() => {
    // Merge parent disabled state with local disabled state if inheritParentDisabled is true
    const effectiveDisabled = inheritParentDisabled
      ? isDisabled || parentContext.disabled
      : isDisabled;

    // we translate from boolean -> (true | undefined) this way because we only want this context
    // to be able to explicitly mark all inputs as disabled; we don't want this component to explicitly *enable*
    // all inputs because we want to delegate the control of that to the form itself, and allowing this
    // component to do that would be a major footgun.
    setDisabled(effectiveDisabled || undefined);
  }, [isDisabled, inheritParentDisabled, parentContext.disabled, setDisabled]);

  return (
    <FormFieldsDisabledContext.Provider value={{ disabled }}>
      {children}
    </FormFieldsDisabledContext.Provider>
  );
};
